import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const opportunityAllocationService = createApi({
    reducerPath: 'opportunityAllocationService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['OpportunityAllocation'],
    endpoints: (builder) => ({

        // ⭐ GET ALL PAGINATED WITH SORT + FILTER
        getAllOpportunityAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityAllocationController.getAllOpportunityAllocation}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ GET BY ID
        getOpportunityAllocationById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityAllocationController.getOpportunityAllocationById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ SAVE
        saveOpportunityAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityAllocationController.saveOpportunityAllocation}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload, 
                };
            }
        }),

        // ⭐ UPDATE
        updateOpportunityAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityAllocationController.updateOpportunityAllocation}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            }
        }),

        // ⭐ DELETE
        deleteOpportunityAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityAllocationController.deleteOpportunityAllocation}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ SEARCH
        getAllOpportunityAllocationBySearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityAllocationController.getAllOpportunityAllocationBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        // ⭐ FIND ALL (NO PAGINATION)
        findAllOpportunityAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityAllocationController.findAllOpportunityAllocation}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            }
        }),

        // ⭐ BULK UPLOAD
        bulkSaveOpportunityAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.opportunityAllocationController.bulkSaveOpportunityAllocation}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload, 
                };
            }
        }),

    }),
});

export const {
    useGetAllOpportunityAllocationMutation,
    useGetOpportunityAllocationByIdMutation,
    useSaveOpportunityAllocationMutation,
    useUpdateOpportunityAllocationMutation,
    useDeleteOpportunityAllocationMutation,
    useGetAllOpportunityAllocationBySearchMutation,
    useFindAllOpportunityAllocationMutation,
    useBulkSaveOpportunityAllocationMutation
} = opportunityAllocationService;
